export default function AppSection() {
  return (
    <section
      id="app"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
          移动客户端
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>

        <div className="mt-10 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="w-48 h-64 md:w-56 md:h-72 rounded-2xl overflow-hidden flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Mobile%20phone%20showing%20video%20streaming%20app%20interface%20with%20movie%20posters%20grid%2C%20clean%20modern%20UI%20design%2C%20warm%20coral%20accent%20colors%2C%20entertainment%20app%20mockup%2C%20professional%20product%20photography%2C%20soft%20natural%20lighting&width=600&height=900&seq=app-mockup-2026&orientation=portrait"
              alt="人人影视移动客户端界面展示"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 text-center md:text-left">
            <h3 className="font-heading text-xl font-semibold text-foreground-900">
              人人影视 APP — 随时随地高清观影
            </h3>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              专为移动端优化的观影体验，支持iOS与Android双平台。延续网页端不缓冲秒播技术核心，
              在手机和平板上同样享受1080P高清画质。支持离线缓存、投屏播放、弹幕互动等实用功能，
              让你在地铁、旅途中也能畅快追剧。免注册即可使用，下载即看，简单方便。
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-3 justify-center md:justify-start">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-foreground-900 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </div>
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </div>
            </div>

            <p className="mt-3 text-xs text-foreground-500">已累计下载超过2000万次 · 评分4.8</p>
          </div>
        </div>
      </div>
    </section>
  );
}